<form [formGroup]="addressForm" class="details-page-edit-form address-form">
  <rkt-icon name="star" class="primary-address-icon"></rkt-icon>
  <rkt-form [form]="addressForm" [fields]="addressFields" [model]="formModel" [options]="options" (modelChange)="onFormUpdate()"></rkt-form>
</form>
